import React from 'react';
import ReactTooltip from 'react-tooltip';
import { PROGRESS_STATUS, SNAPSHOT_TEST } from 'utils/constants';
import Tooltip from 'components/common/Tooltip';
import _ from 'lodash';
import {
  LessonGroupProgressDTO,
  LessonProgressDTO,
} from '@peartherapeutics/hylia-api-client';
import moment from 'moment';
import styles from './styles.module.scss';

const progressStatus = (status: string) => {
  switch (status) {
    case PROGRESS_STATUS.REVISITED:
      return <div className={styles.revisited}>Revisited</div>;
    case PROGRESS_STATUS.COMPLETED:
      return <div className={styles.completed}>Completed</div>;
    case PROGRESS_STATUS.IN_PROGRESS:
      return <div className={styles['in-progress']}>In Progress</div>;
    case PROGRESS_STATUS.UNLOCKED:
      return <div className={styles['unlocked-icon']} />;
    default:
      return <div className={styles['locked-icon']} />;
  }
};

/** Allows ToolTip to render based on env var for snapshot tests */
const SnapshotToolTip = (lesson: LessonProgressDTO) => {
  const content = (
    <span className={styles['completed-events-count']}>
      &ensp;({lesson.completionDates!.length})
    </span>
  );

  return SNAPSHOT_TEST ? (
    <span>{content}</span>
  ) : (
    <Tooltip
      title={
        <>
          {lesson.completionDates!.map((date) => (
            <span key={date}>
              {moment(date).format('l')}
              <br />
            </span>
          ))}
        </>
      }
      placement="top"
    >
      {content}
    </Tooltip>
  );
};

/** Allows ToolTip to render based on env var for snapshot tests */
const SnapshotReactToolTip = () => {
  const content = <span>Download Lesson Worksheet</span>;

  return SNAPSHOT_TEST ? (
    <span>{content}</span>
  ) : (
    <ReactTooltip
      id="worksheet"
      place="bottom"
      type="dark"
      effect="solid"
      className={styles['custom-tooltip']}
    >
      {content}
    </ReactTooltip>
  );
};

const Table = ({
  lessonGroups,
}: {
  lessonGroups: LessonGroupProgressDTO[];
}) => {
  return (
    <div className={styles.container}>
      {lessonGroups &&
        lessonGroups.map((lessonGroup: LessonGroupProgressDTO) => {
          // ensure test id does not contain white spaces
          const sectionId = _.kebabCase(lessonGroup.name);
          return (
            <div
              key={`section-${lessonGroup.name}`}
              data-testid={`section-${sectionId}`}
            >
              <div className={styles.header}>
                <span className={styles['section-name']}>
                  {lessonGroup.name}
                </span>
                <span className={styles['completed-modules']}>
                  {`${lessonGroup.lessonsCompleted} of ${lessonGroup.lessons.length} completed`}
                </span>
              </div>
              <table className={styles['module-detail']}>
                <thead>
                  <tr>
                    <th className={styles.title}>Title</th>
                    <th className={styles.progress}>Progress</th>
                    <th>Completion Date</th>
                    <th>Total Time (min)</th>
                  </tr>
                </thead>
                <tbody>
                  {lessonGroup.lessons &&
                    lessonGroup.lessons.map((lesson: LessonProgressDTO) => {
                      return (
                        <tr key={`detail-${lesson.name || ''}`}>
                          <td className={styles.title}>
                            {lesson.name ? `${lesson.name} ` : ''}
                            {lesson.id && lesson.worksheetPath && (
                              /* eslint-disable jsx-a11y/anchor-has-content */
                              <a
                                data-tip
                                data-for="worksheet"
                                href={lesson.worksheetPath}
                                className={styles.link}
                                target="_blank"
                                rel="noopener noreferrer"
                              />
                            )}
                            {SnapshotReactToolTip()}
                          </td>
                          <td>
                            <span>{progressStatus(lesson.type)}</span>
                          </td>
                          <td data-testid="completion-date">
                            {lesson.lastCompletionDate &&
                              moment(lesson.lastCompletionDate).format('l')}
                            {lesson.completionDates &&
                              lesson.completionDates.length > 1 &&
                              SnapshotToolTip(lesson)}
                          </td>
                          <td>
                            {lesson.totalTimeSpentMins % 1 === 0
                              ? lesson.totalTimeSpentMins
                              : lesson.totalTimeSpentMins.toFixed(3)}
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          );
        })}
    </div>
  );
};

export default Table;
